import { get } from 'lodash';
import type { ServiceCode } from '@common/enums';
import { serviceLabels } from './serviceLabels';

export type LabelType =
    | 'costInfoAndConsentModal'
    | 'createProcedure'
    | 'createRequest'
    | 'deviantAlert'
    | 'diagnosticReport'
    | 'diagnosticReportInProcedure'
    | 'email'
    | 'patientDossier'
    | 'procedure'
    | 'procedureAttachment'
    | 'processTitle'
    | 'processWizard'
    | 'request'
    | 'supervision'
    | 'toast'
    | 'workList';

export function getServiceLabel(code: ServiceCode, labelType: LabelType): string | undefined;
export function getServiceLabel(code: ServiceCode, labelType: LabelType, defaultLabel: string): string;
export function getServiceLabel(code: ServiceCode, labelType: LabelType, defaultLabel?: string) {
    if (defaultLabel) {
        return get(serviceLabels, [code, labelType], defaultLabel);
    } else {
        return get(serviceLabels, [code, labelType]);
    }
}
